import type { AffiliateEstado, VehicleDisponibilidad } from "@/types";

export interface AffiliateEstadoMeta {
  value: AffiliateEstado;
  label: string;
  badge: string;
  dot: string;
}

export const estadosAfiliado: AffiliateEstadoMeta[] = [
  {
    value: "pendiente",
    label: "Pendiente",
    badge: "bg-primary-100 text-primary-800 border-primary-200",
    dot: "bg-primary-500",
  },
  {
    value: "en_revision",
    label: "En revisión",
    badge: "bg-secondary-100 text-secondary-900 border-secondary-200",
    dot: "bg-secondary-500",
  },
  {
    value: "info_adicional",
    label: "Info. adicional requerida",
    badge: "bg-accent-100 text-accent-900 border-accent-200",
    dot: "bg-accent-500",
  },
  {
    value: "aprobado",
    label: "Aprobado",
    badge: "bg-primary-100 text-primary-800 border-primary-300",
    dot: "bg-primary-600",
  },
  {
    value: "activo",
    label: "Activo",
    badge: "bg-secondary-100 text-secondary-900 border-secondary-300",
    dot: "bg-secondary-600",
  },
  {
    value: "suspendido",
    label: "Suspendido",
    badge: "bg-background-200 text-foreground-700 border-background-300",
    dot: "bg-foreground-500",
  },
  {
    value: "rechazado",
    label: "Rechazado",
    badge: "bg-background-200 text-foreground-600 border-background-300",
    dot: "bg-foreground-400",
  },
];

const fallback: AffiliateEstadoMeta = {
  value: "pendiente",
  label: "Pendiente",
  badge: "bg-background-200 text-foreground-600 border-background-300",
  dot: "bg-foreground-400",
};

export function getAfiliadoEstadoMeta(value?: string | null): AffiliateEstadoMeta {
  if (!value) return fallback;
  return (
    estadosAfiliado.find((estado) => estado.value === value) ?? {
      ...fallback,
      value: value as AffiliateEstado,
      label: value,
    }
  );
}

export function disponibilidadLabel(value?: string | null): string {
  const map: Record<VehicleDisponibilidad, string> = {
    disponible: "Disponible",
    por_solicitud: "Disponible por solicitud",
    no_disponible: "No disponible temporalmente",
  };
  return map[(value as VehicleDisponibilidad) ?? "disponible"] ?? "Disponible";
}

export function tipoAfiliadoLabel(value?: string | null): string {
  if (value === "empresa") return "Empresa de transporte";
  if (value === "independiente") return "Propietario / Independiente";
  return "—";
}